@if (showSpinner) {
  <app-loader> </app-loader>
}

<main class="content-wrapper">
  <div class="main-wrapper">
    <div class="header-wrapper">
      <div class="header-cards available-card">
        <div class="card-head">
          <div class="icon-circle available-icon">
            <img src="../../../assets/theme1/all-emp.png" alt="icon missing" />
          </div>
          <h1>Available Leaves </h1>
        </div>
        <div class="card-body available-title">
          <h1>{{ total_leaves - (paidLeaves + pendingLeaves) | number:'1.0-2' }}</h1>
          <img data-toggle="modal" data-target="#leaveinfoModal" (click)="leaveInfo()"
            src="../../../assets/theme1/info-icon.png" alt="missing icon" />
          </div>
        </div>

        <div class="modal fade" id="leaveinfoModal" tabindex="-1" role="dialog" aria-labelledby="leaveinfoModalLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
            <div class="modal-content ">
              <div class="modal-header">
                <h5 class="modal-title" id="leaveinfoModalLabel">Leave Count Detail</h5>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body info-modal-body">
                <div class="row">
                  <div class="col-4 p-0">
                    <div class="col-head">
                      Category
                    </div>
                  </div>
                  <div class="col-4 p-0">
                    <div class="col-data col-center">
                      Assign Leaves
                    </div>
                  </div>
                  <div class="col-4 p-0">
                    <div class="col-data col-center">
                      Remaining Leaves
                    </div>
                  </div>
                  @for (item of remainleaves; track item) {
                    <div class="col-4 p-0">
                      <div class="col-head">
                        {{item.leave_name | titlecase
                        }} <span class="leave_type">({{item.leave_type | titlecase }})</span>
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-data col-center assign-leave-bg">
                        <div>
                          {{item.assigned_leaves | number:'1.0-2'}}
                        </div>
                      </div>
                    </div>
                    <div class="col-4 p-0">
                      <div class="col-data col-center remaining-leave-bg">
                        <div>
                          {{item.assigned_leaves - item.leave_count  | number:'1.0-2'}}
                        </div>
                      </div>
                    </div>
                  }
                </div>
              </div>

            </div>
          </div>
        </div>

        <div class="header-cards approve-card">
          <div class="card-head">
            <div class="icon-circle approve-icon">
              <img src="../../../assets/theme1/late.png" alt="icon missing" />
            </div>
            <h1>Approved Paid Leaves </h1>
          </div>
          <div class="card-body approve-title">
            <h1>{{ paidLeaves | number:'1.0-2'}}</h1>
          </div>
        </div>

        <div class="header-cards reject-card">
          <div class="card-head">
            <div class="icon-circle reject-icon">
              <img src="../../../assets/theme1/reject-leave.png" alt="icon missing" />
            </div>
            <h1>Reject Leaves </h1>
          </div>
          <div class="card-body reject-title">
            <h1>{{ rejectedLeaves }}</h1>
          </div>
        </div>

        <div class="header-cards renew-card">
          <div class="card-head">
            <div class="icon-circle renew-icon">
              <img src="../../../assets/theme1/reneew.png" alt="icon missing" />
            </div>
            <h1>Renew Leaves </h1>
          </div>
          <div class="card-body renew-title">
            <h1>{{ userInfo.modify_date | date: 'dd MMM yyyy' }}</h1>
          </div>
        </div>

        <div class="header-cards apply-card" [routerLink]="['/user-leaves']">
          <div class="icon-circle apply-icon">
            <img src="../../../assets/theme1/plus.png" alt="icon missing" />
          </div>
          <h1>Apply Leave </h1>
        </div>

      </div>
      <div class="body-wrapper mt-4">
        <div class="filter-wrapper">
          <h1>
            Filter
          </h1>
          <div>
            <form class="filter-fields" id="form-link-outside-btn" #f="ngForm" (ngSubmit)="onSubmit(f)">
              <div class="form-group">
                <input type="text" name="title" [(ngModel)]="title" placeholder="Enter Leave Name.." class="form-control">
              </div>
              <div class="form-group">
                <input type="text" id="date-input1" name="start_date" [(ngModel)]="startDate"
                  class="form-control custom-date-input" placeholder="Select Start Date" (focus)="onFocus($event)"
                  (blur)="onBlur($event)">
                </div>

                <div class="form-group">
                  <input type="text" id="date-input" name="end_date" [(ngModel)]="endDate"
                    class="form-control custom-date-input" placeholder="Select End Date" (focus)="onFocus($event)"
                    (blur)="onBlur($event)">
                  </div>

                  <button class="" type="submit" class="btn leave-save apply-button"
                  form="form-link-outside-btn">Apply</button>
                </form>


              </div>

            </div>

            <!-- approve -->
            @for (type of typeArr; track type) {
              <div class="table-wrapper pb-1">
                <!-- accepted-table -->
                @if (type.status === 'approved') {
                  <table class=" mt-4">
                    <thead class="accepted-main-head">
                      <tr>
                        <th colspan="3" class="main-head-th ">
                          <h1>Approved Leave @if (type.leave_type_id == 2) {
                            <span>- Full Leave</span>
                          }
                          @if (type.leave_type_id == 3) {
                            <span>- Short Leave</span>
                          }
                        </h1>
                      </th>
                      <th class="main-head-th right-heading appove-head-th">
                        <div style="display:flex;align-items:center;justify-content:center;gap:8px;">
                          <div>
                            <img src="../../../assets/theme1/check-circle.png" alt="Missing icon">
                            Accepted
                          </div>
                          @if (type.monthly_sequence > 2) {
                            <span style="background:#ffeaa7;color:#d63031;padding:4px 8px;border-radius:10px;font-size:11px;font-weight:600;display:inline-flex;align-items:center;gap:4px;white-space:nowrap;">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 9v2m0 4v2m8.228-2.228l-1.414-1.414M6.586 6.586L5.172 5.172M18 12a6 6 0 11-12 0 6 6 0 0112 0z"></path></svg>
                              {{ type.monthly_sequence | ordinal:true }}
                            </span>
                          }
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="approve-tbody">
                    <tr>
                      <th>Leave Name</th>
                      <td>{{ type.title }}</td>
                      @if (type.leave_type_id == 2) {
                        <th>Number of Leaves</th>
                      }
                      @if (type.leave_type_id == 2) {
                        <td>{{ calculateDiff(type.start_date, type.end_date) }}</td>
                      }
                      @if (type.leave_type_id == 3 && (!type.shortLeave_hours || type.shortLeave_hours == 0 || type.shortLeave_hours === '')) {
                        <th
                          >
                        Number of Leaves</th>
                      }
                      @if (type.leave_type_id == 3 && (!type.shortLeave_hours || type.shortLeave_hours == 0 || type.shortLeave_hours === '')) {
                        <td
                          >
                        0.5</td>
                      }
                      @if (type.leave_type_id == 3 && (type.shortLeave_hours !== null && type.shortLeave_hours !== undefined && type.shortLeave_hours != 0 && type.shortLeave_hours !== '')) {
                        <th
                          >
                        Number of Hours</th>
                      }
                      @if (type.leave_type_id == 3 && (type.shortLeave_hours !== null && type.shortLeave_hours !== undefined && type.shortLeave_hours != 0 && type.shortLeave_hours !== '')) {
                        <td
                          >
                        {{ type.shortLeave_hours }}</td>
                      }
                    </tr>
                    <tr>
                      <th>Start Date</th>
                      <td> {{ type.start_date | date:'MMM dd, yyyy' }}</td>
                      <th>End Date</th>
                      <td> {{ type.end_date | date:'MMM dd, yyyy' }}</td>
                    </tr>
                    @if (type.leave_type_id == 3 && (type.shortLeave_hours !== null && type.shortLeave_hours !== undefined && type.shortLeave_hours != 0 && type.shortLeave_hours !== '') ) {
                      <tr
                        >
                        <th>Start Time</th>
                        <td> {{
                          type.shortLeave_start_time.slice(0, 5) }}
                        </td>
                        <th>End Time</th>
                        <td> {{
                          type.shortLeave_end_time.slice(0, 5) }}
                        </td>
                      </tr>
                    }
                    <tr>
                      <th>Leave Type</th>
                      <td> {{ type.leave_name |titlecase }}<span class="leave_name_type">({{type.leave_payment_status |
                      titlecase}})</span></td>
                      <th>Application Date</th>
                      <td> {{ type.applied_date | date:'MMM dd, yyyy'}}</td>
                    </tr>
                    <tr>
                      <th>Leave Description</th>
                      <!-- <td colspan="3">{{ type.description }}</td> -->
                      <td colspan="3" [innerHTML]="type.description"></td>
                    </tr>
                    <tr>
                      <th>Authorization</th>
                      <td colspan="3">
                        <div class="auth-card-flex">
                          @for (detail of type.leave_details; track detail) {
                            <div class="auth-card-main">
                              <div class="auth-cards">
                                <div class="auth-card-head mb-2">
                                  <div
                                    [ngClass]="{'auth-img-aprrove': detail.status === 'approved', 'auth-img': detail.status === 'rejected', 'auth-img-recommend': detail.status === 'recommended'}">
                                    <img
                                      [src]="detail.admin.profile_image ? detail.admin.profile_image : 'assets/images/question.jpg'"
                                      alt="Missing Image" />
                                    </div>
                                  </div>
                                  <div class="auth-body">
                                    <h1>{{ detail.admin.first_name }} {{ detail.admin.last_name }}</h1>
                                    <h2>{{ detail.action_date | date:'MMM dd, yyyy' }}</h2>
                                    <p
                                      [ngClass]="{'color-auth-body-approved': detail.status === 'approved', 'color-auth-body-recommend': detail.status === 'recommended'}">
                                      @if (detail.status === 'approved') {
                                        <img src="../../../assets/theme1/check-circle.png"
                                          alt="Missing icon">
                                      }
                                      @if (detail.status === 'recommended') {
                                        <img src="../../../assets/theme1/forward-circle.png"
                                          alt="Missing icon">
                                      }
                                      {{ detail.status | titlecase }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                }
                <!-- rejected -->
                @if (type.status === 'rejected') {
                  <table class=" mt-4">
                    <thead class="rejected-main-head">
                      <tr>
                        <th colspan="3" class="main-head-th ">
                          <h1>Rejected Leaves @if (type.leave_type_id == 2) {
                            <span>- Full Leave</span>
                          }
                          @if (type.leave_type_id == 3) {
                            <span>- Short Leave</span>
                          }
                        </h1>
                      </th>
                      <th class="main-head-th right-heading rejected-head-th">
                        <div style="display:flex;align-items:center;justify-content:center;gap:8px;">
                          <div>
                            <img src="../../../assets/theme1/cross-icon.png" alt="Missing icon">
                            Rejected
                          </div>
                          @if (type.monthly_sequence > 2) {
                            <span style="background:#ffeaa7;color:#d63031;padding:4px 8px;border-radius:10px;font-size:11px;font-weight:600;display:inline-flex;align-items:center;gap:4px;white-space:nowrap;">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 9v2m0 4v2m8.228-2.228l-1.414-1.414M6.586 6.586L5.172 5.172M18 12a6 6 0 11-12 0 6 6 0 0112 0z"></path></svg>
                              {{ type.monthly_sequence | ordinal:true }}
                            </span>
                          }
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="rejected-tbody">
                    <tr>
                      <th>Leave Name</th>
                      <td>{{ type.title }}</td>
                      @if (type.leave_type_id == 2) {
                        <th>Number of Leaves</th>
                      }
                      @if (type.leave_type_id == 2) {
                        <td>{{ calculateDiff(type.start_date, type.end_date) }}</td>
                      }
                      @if (type.leave_type_id == 3 && (!type.shortLeave_hours || type.shortLeave_hours == 0 || type.shortLeave_hours === '')) {
                        <th
                          >
                        Number of Leaves</th>
                      }
                      @if (type.leave_type_id == 3 && (!type.shortLeave_hours || type.shortLeave_hours == 0 || type.shortLeave_hours === '')) {
                        <td
                          >
                        0.5</td>
                      }
                      @if (type.leave_type_id == 3 && (type.shortLeave_hours !== null && type.shortLeave_hours !== undefined && type.shortLeave_hours != 0 && type.shortLeave_hours !== '')) {
                        <th
                          >
                        Number of Hours</th>
                      }
                      @if (type.leave_type_id == 3 && (type.shortLeave_hours !== null && type.shortLeave_hours !== undefined && type.shortLeave_hours != 0 && type.shortLeave_hours !== '')) {
                        <td
                          >
                        {{ type.shortLeave_hours }}</td>
                      }
                      <!-- <th>Number of Leaves</th>
                      <td *ngIf="type.leave_type_id == 2">{{ calculateDiff(type.start_date, type.end_date) }}</td>
                      <td *ngIf="type.leave_type_id == 3">0.5</td> -->
                    </tr>
                    <tr>
                      <th>Start Date</th>
                      <td> {{ type.start_date | date:'MMM dd, yyyy' }}</td>
                      <th>End Date</th>
                      <td> {{ type.end_date | date:'MMM dd, yyyy' }}</td>
                    </tr>
                    @if (type.leave_type_id == 3 && (type.shortLeave_hours !== null && type.shortLeave_hours !== undefined && type.shortLeave_hours != 0 && type.shortLeave_hours !== '') ) {
                      <tr
                        >
                        <th>Start Time</th>
                        <td> {{
                          type.shortLeave_start_time.slice(0, 5) }}
                        </td>
                        <th>End Time</th>
                        <td> {{
                          type.shortLeave_end_time.slice(0, 5) }}
                        </td>
                      </tr>
                    }
                    <tr>
                      <th>Leave Type</th>
                      <td> {{ type.leave_name |titlecase }}<span class="leave_name_type">({{type.leave_payment_status |
                      titlecase}})</span></td>
                      <th>Application Date</th>
                      <td> {{ type.applied_date | date:'MMM dd, yyyy' }}</td>
                    </tr>
                    <tr>
                      <th>Leave Description</th>
                      <!-- <td colspan="3">{{ type.description }}</td> -->
                      <td colspan="3" [innerHTML]="type.description"></td>
                    </tr>
                    <tr>
                      <th>Authorization</th>
                      <td colspan="3">
                        <div class="auth-card-flex">
                          @for (detail of type.leave_details; track detail) {
                            <div class="auth-card-main">
                              <div class="auth-cards">
                                <div class="auth-card-head mb-2">
                                  <div
                                    [ngClass]="{'auth-img-aprrove': detail.status === 'approved', 'auth-img': detail.status === 'rejected', 'auth-img-recommend': detail.status === 'recommended'}">
                                    <img
                                      [src]="detail.admin.profile_image ? detail.admin.profile_image : 'assets/images/question.jpg'"
                                      alt="Missing Image" />
                                    </div>
                                  </div>
                                  <div class="auth-body">
                                    <h1>{{ detail.admin.first_name }} {{ detail.admin.last_name }}</h1>
                                    <h2>{{ detail.action_date | date:'MMM dd, yyyy' }}
                                      @if (detail.status === 'rejected') {
                                        <img data-toggle="modal" data-target="#leavereason"
                                          (click)="detailAdmin(detail)" src="../../../assets/theme1/info-circle.png"
                                          alt="Missing icon">
                                      }
                                    </h2>
                                    @if (detail.status === 'rejected') {
                                      <p class="rejected-case">
                                        <img src="../../../assets/theme1/cross-icon.png" alt="Missing icon">
                                        {{ detail.status | titlecase }}
                                      </p>
                                    }
                                    @if (detail.status === 'recommended') {
                                      <p class="color-auth-body-recommend">
                                        <img src="../../../assets/theme1/forward-circle.png" alt="Missing icon">
                                        {{ detail.status | titlecase }}
                                      </p>
                                    }
                                    @if (detail.status === 'approved') {
                                      <p class="color-auth-body-approved">
                                        <img src="../../../assets/theme1/check-circle.png" alt="Missing icon">
                                        {{ detail.status | titlecase }}
                                      </p>
                                    }
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                }
                <div class="modal fade" id="leavereason" tabindex="-1" role="dialog" aria-labelledby="leavereasonLabel"
                  aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                    <div class="modal-content ">
                      <div class="modal-header reject-reason-head">
                        <h5 class="modal-title" id="leavereasonLabel">Leave Reject Reason</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                      </div>
                      <div class="modal-body info-modal-body">
                        @if (Admin_detail && Admin_detail.admin) {
                          <div class="row">
                            <div class="col-12">
                              <div class="modal-image reason-image">
                                <img src="../../../assets/theme1/reason-modal.png" alt="Missing icon" />
                                <h1>Why Your Leave Application Is Being Rejected?</h1>
                              </div>
                            </div>
                            <div class="col-4 p-0">
                              <div class="col-head reason-head">
                                Admin
                              </div>
                            </div>
                            <div class="col-8 p-0">
                              <div class="col-data reason-body admin-name-dep">
                                {{Admin_detail.admin.first_name}} {{ Admin_detail.admin.last_name }}
                                <span>{{Admin_detail.admin.department}} </span>
                              </div>
                            </div>
                            <div class="col-4 p-0">
                              <div class="col-head reason-head">
                                Status
                              </div>
                            </div>
                            <div class="col-8 p-0">
                              <div class="col-data reason-body reject-status">
                                <img src="../../../assets/theme1/cross-icon.png" alt="Missing icon">
                                {{Admin_detail.status |titlecase}}
                              </div>
                            </div>
                            <div class="col-4 p-0">
                              <div class="col-head reason-head">
                                Action Date
                              </div>
                            </div>
                            <div class="col-8 p-0">
                              <div class="col-data reason-body">
                                {{Admin_detail.action_date | date:'MMM dd, yyyy'}}
                              </div>
                            </div>
                            <div class="col-4 p-0">
                              <div class="col-head description-body reason-head">
                                Reason
                              </div>
                            </div>
                            <div class="col-8 p-0">
                              <div class="col-data description-body reason-body">
                                {{Admin_detail.reason}}
                              </div>
                            </div>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                </div>
                <!-- pending -->
                @if (type.status === 'pending') {
                  <table class=" mt-4">
                    <thead class="pending-main-head">
                      <tr>
                        <th colspan="3" class="main-head-th ">
                          <h1>@if (type.status === 'pending') {
                            <span>Leaves Request Pending </span>
                          }
                          @if (type.leave_type_id == 2) {
                            <span>- Full Leave</span>
                          }
                          @if (type.leave_type_id == 3) {
                            <span>- Short Leave</span>
                          }
                        </h1>
                      </th>
                      <th class="main-head-th right-heading pending-head-th ">
                        <div style="display:flex;align-items:center;justify-content:flex-end;gap:8px;flex-wrap:wrap;width:100%;">
                          <div style="display:flex;align-items:center;gap:8px;">
                            <div class="pending-circle edit-circle-img" (click)="editLeave(type)" style="margin:0;">
                              <img src="../../../assets/theme1/edit.png" alt="missing icone" />
                            </div>
                            <div class="pending-circle2" data-toggle="modal" data-target="#leaveDelete"
                              (click)="deleteDetail(type)">
                              <i class="fa fa-trash-o"></i>
                            </div>
                          </div>
                          @if (type.monthly_sequence > 2) {
                            <span style="background:#ffeaa7;color:#d63031;padding:4px 8px;border-radius:10px;font-size:11px;font-weight:600;display:inline-flex;align-items:center;gap:4px;white-space:nowrap;margin-top:4px;cursor:pointer;position:relative;" [attr.data-tooltip]="'This leave might be rejected as it\'s against the policy - you can only apply 2 leaves in a month'">
                              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 9v2m0 4v2m8.228-2.228l-1.414-1.414M6.586 6.586L5.172 5.172M18 12a6 6 0 11-12 0 6 6 0 0112 0z"></path></svg>
                              {{ type.monthly_sequence | ordinal:true }}
                            </span>
                          }
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="pending-tbody">
                    <tr>
                      <th>Leave Name</th>
                      <td>{{ type.title }}</td>
                      @if (type.leave_type_id == 2) {
                        <th>Number of Leaves</th>
                      }
                      @if (type.leave_type_id == 2) {
                        <td>{{ calculateDiff(type.start_date, type.end_date) }}</td>
                      }
                      @if (type.leave_type_id == 3 && (!type.shortLeave_hours || type.shortLeave_hours == 0 || type.shortLeave_hours === '')) {
                        <th
                          >
                        Number of Leaves</th>
                      }
                      @if (type.leave_type_id == 3 && (!type.shortLeave_hours || type.shortLeave_hours == 0 || type.shortLeave_hours === '')) {
                        <td
                          >
                        0.5</td>
                      }
                      @if (type.leave_type_id == 3 && (type.shortLeave_hours !== null && type.shortLeave_hours !== undefined && type.shortLeave_hours != 0 && type.shortLeave_hours !== '')) {
                        <th
                          >
                        Number of Hours</th>
                      }
                      @if (type.leave_type_id == 3 && (type.shortLeave_hours !== null && type.shortLeave_hours !== undefined && type.shortLeave_hours != 0 && type.shortLeave_hours !== '')) {
                        <td
                          >
                        {{ type.shortLeave_hours }}</td>
                      }
                    </tr>
                    <tr>
                      <th>Start Date</th>
                      <td> {{ type.start_date | date:'MMM dd, yyyy' }}</td>
                      <th>End Date</th>
                      <td> {{ type.end_date | date:'MMM dd, yyyy' }}</td>
                    </tr>
                    @if (type.leave_type_id == 3 && (type.shortLeave_hours !== null && type.shortLeave_hours !== undefined && type.shortLeave_hours != 0 && type.shortLeave_hours !== '') ) {
                      <tr
                        >
                        <th>Start Time</th>
                        <td> {{
                          type.shortLeave_start_time.slice(0, 5) }}
                        </td>
                        <th>End Time</th>
                        <td> {{
                          type.shortLeave_end_time.slice(0, 5) }}
                        </td>
                      </tr>
                    }
                    <tr>
                      <th>Leave Type</th>
                      <td> {{ type.leave_name |titlecase }}<span class="leave_name_type">({{type.leave_payment_status |
                      titlecase}})</span></td>
                      <th>Application Date</th>
                      <td> {{ type.applied_date | date:'MMM dd, yyyy' }}</td>
                    </tr>
                    <tr>
                      <th>Leave Description</th>
                      <!-- <td colspan="3">{{ type.description }}</td> -->
                      @if (!type.leave_doc) {
                        <td colspan="3" [innerHTML]="type.description"></td>
                      }
                      @if (type.leave_doc) {
                        <td colspan="2" [innerHTML]="type.description"></td>
                      }
                      @if (type.leave_doc) {
                        <td>
                          <div class="document-image" data-toggle="modal" data-target="#imagemodal"
                            (click)="imageModaldata(type.leave_doc)">
                            <div class="medical-icon-server">
                              <img src="../../../assets/theme1/file-06.png" alt="Missing">
                            </div>
                            <p>Leave Doc</p>
                          </div>
                        </td>
                      }
                    </tr>
                  </tbody>
                </table>
              }
              <!-- Recommended -->
              @if (type.status === 'recommended') {
                <table class=" mt-4">
                  <thead class="recommended-main-head">
                    <tr>
                      <th colspan="3" class="main-head-th ">
                        <h1>Leave Recommended
                          @if (type.leave_type_id == 2) {
                            <span>- Full Leave</span>
                          }
                          @if (type.leave_type_id == 3) {
                            <span>- Short Leave</span>
                          }
                        </h1>
                      </th>
                      <th class="main-head-th right-heading recommended-head-th">
                        <p>
                          <img src="../../../assets/theme1/forward-circle.png" alt="Missing icon">
                          Recommended
                        </p>
                      </th>
                    </tr>
                  </thead>
                  <tbody class="recommended-tbody">
                    <tr>
                      <th>Leave Name</th>
                      <td>{{ type.title }}</td>
                      @if (type.leave_type_id == 2) {
                        <th>Number of Leaves</th>
                      }
                      @if (type.leave_type_id == 2) {
                        <td>{{ calculateDiff(type.start_date, type.end_date) }}</td>
                      }
                      @if (type.leave_type_id == 3 && (!type.shortLeave_hours || type.shortLeave_hours == 0 || type.shortLeave_hours === '')) {
                        <th
                          >
                        Number of Leaves</th>
                      }
                      @if (type.leave_type_id == 3 && (!type.shortLeave_hours || type.shortLeave_hours == 0 || type.shortLeave_hours === '')) {
                        <td
                          >
                        0.5</td>
                      }
                      @if (type.leave_type_id == 3 && (type.shortLeave_hours !== null && type.shortLeave_hours !== undefined && type.shortLeave_hours != 0 && type.shortLeave_hours !== '')) {
                        <th
                          >
                        Number of Hours</th>
                      }
                      @if (type.leave_type_id == 3 && (type.shortLeave_hours !== null && type.shortLeave_hours !== undefined && type.shortLeave_hours != 0 && type.shortLeave_hours !== '')) {
                        <td
                          >
                        {{ type.shortLeave_hours }}</td>
                      }
                    </tr>
                    <tr>
                      <th>Start Date</th>
                      <td> {{ type.start_date | date:'MMM dd, yyyy' }}</td>
                      <th>End Date</th>
                      <td> {{ type.end_date | date:'MMM dd, yyyy' }}</td>
                    </tr>
                    @if (type.leave_type_id == 3 && (type.shortLeave_hours !== null && type.shortLeave_hours !== undefined && type.shortLeave_hours != 0 && type.shortLeave_hours !== '') ) {
                      <tr
                        >
                        <th>Start Time</th>
                        <td> {{
                          type.shortLeave_start_time.slice(0, 5) }}
                        </td>
                        <th>End Time</th>
                        <td> {{
                          type.shortLeave_end_time.slice(0, 5) }}
                        </td>
                      </tr>
                    }
                    <tr>
                      <th>Leave Type</th>
                      <td> {{ type.leave_name |titlecase }}<span class="leave_name_type">({{type.leave_payment_status |
                      titlecase}})</span></td>
                      <th>Application Date</th>
                      <td> {{ type.applied_date | date:'MMM dd, yyyy'}}</td>
                    </tr>
                    <tr>
                      <th>Leave Description</th>
                      <!-- <td colspan="3">{{ type.description }}</td> -->
                      <td colspan="3" [innerHTML]="type.description"></td>
                    </tr>
                    <tr>
                      <th>Authorization</th>
                      <td colspan="3">
                        <div class="auth-card-flex">
                          @for (detail of type.leave_details; track detail) {
                            <div class="auth-card-main">
                              <div class="auth-cards">
                                <div class="auth-card-head mb-2">
                                  <div
                                    [ngClass]="{'auth-img-aprrove': detail.status === 'approved', 'auth-img': detail.status === 'rejected', 'auth-img-recommend': detail.status === 'recommended'}">
                                    <img
                                      [src]="detail.admin.profile_image ? detail.admin.profile_image : 'assets/images/question.jpg'"
                                      alt="Missing Image" />
                                    </div>
                                  </div>
                                  <div class="auth-body">
                                    <h1>{{ detail.admin.first_name }} {{ detail.admin.last_name }}</h1>
                                    <h2>{{ detail.action_date | date:'MMM dd, yyyy' }}</h2>
                                    <p
                                      [ngClass]="{'color-auth-body-approved': detail.status === 'approved', 'color-auth-body-recommend': detail.status === 'recommended'}">
                                      @if (detail.status === 'approved') {
                                        <img src="../../../assets/theme1/check-circle.png"
                                          alt="Missing icon">
                                      }
                                      @if (detail.status === 'recommended') {
                                        <img src="../../../assets/theme1/forward-circle.png"
                                          alt="Missing icon">
                                      }
                                      {{ detail.status | titlecase }}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            }
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                }
              </div>
            }


            <div class="modal fade" id="imagemodal" tabindex="-1" role="dialog" aria-labelledby="imagemodalLabel"
              aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content image-modal-content ">
                  <div class="modal-header image-modal-header">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body image-modal-body">
                    <img class="" [src]="modalImage" alt="missing">
                  </div>

                </div>
              </div>
            </div>






            <div class="modal fade" id="leaveDelete" tabindex="-1" role="dialog" aria-labelledby="leaveDeleteLabel"
              aria-hidden="true">
              <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
                <div class="modal-content ">
                  <div class="modal-header">
                    <h5 class="modal-title" id="leaveDeleteLabel">Are You Sure You Want To Delete This Leave!</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body info-modal-body">
                    <div class="row">
                      <div class="col-12">
                        <div class="modal-image">
                          <img src="../../../assets/theme1/questions2.webp" alt="Missing icon" />
                        </div>
                      </div>
                      <div class="col-12">
                        <div class="modal-buttons">
                          <div data-dismiss="modal" aria-label="Close" class="modal-button modal-cancel-btn">
                            No
                          </div>
                          <div class="modal-button modal-submit-btn" (click)="deleteLeave(deleteValueModal)">
                            Yes
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>




          </div>
        </div>
      </main>